import { Component } from '@angular/core';

import { Platform } from '../../../../../platform-call';
import { CaMeetService } from '../../../meet/ca-meet-back-ref';
import { TranslationKeyMap } from '../../ca-analysis-dialog.i18n';

@Component({
    selector: 'cmps-ca-analysis-dialog-call-bar',
    templateUrl: './call-bar.component.html',
})
export class CallBarComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _Platform = Platform;

    constructor(
        // @Inject(CMPS_MEET_BACK_REF)
        // private readonly _caMeetService: CaMeetBackRef,
        private readonly _caMeetService2: CaMeetService,
    ) {}

    /** @private */
    _onCallClick(platform: Platform): void {
        this._caMeetService2.startCall(platform);
    }
}
